import React from 'react';
import { MdArrowDownward, MdArrowUpward } from 'react-icons/md';

import { Icon } from '../icon';

type SortIconProps = {
  isSorted: boolean;
  isDesc?: boolean;
};

export const SortIcon = ({ isSorted, isDesc }: SortIconProps) =>
  isSorted ? (
    <Icon
      className="ml-1"
      aria-hidden
      size="16"
      icon={isDesc ? <MdArrowDownward /> : <MdArrowUpward />}
    />
  ) : null;
